export const environment = {
  production: false,

  // appUrl: "https://standardapi.yoryosolutions.com",
  appUrl: "https://kohinoorspringapp.azurewebsites.net",

  // appUrl: "http://localhost:8080",
  // firebase: {
  //   apiKey: "AIzaSyCVPlWKeskWr20Q_S-0jr113Ilv_Gf762k",
  //   authDomain: "yoryoandroidapp.firebaseapp.com",
  //   databaseURL: "https://yoryoandroidapp.firebaseio.com",
  //   projectId: "yoryoandroidapp",
  //   storageBucket: "yoryoandroidapp.appspot.com",
  //   messagingSenderId: "249812801134"
  // },

  
  // Satnam
  firebase: {
    apiKey: "AIzaSyB8wAPB2B6L215nb_9jj-9WzMTDjq0feng",
    
    authDomain: "http://yoryo-android-firebase-app.firebaseapp.com",
    databaseURL: "https://yoryo-android-firebase-app-default-rtdb.firebaseio.com",
    projectId: "yoryo-android-firebase-app",
    storageBucket: "http://yoryo-android-firebase-app.appspot.com",
    messagingSenderId: "187783228818",
    appId: "1:187783228818:web:754eadfd2e0702e227e54b",
    measurementId: "G-D6PRMECGRN"
  },

  S3Key: {
    accessKeyId: 'AKIAXQQEGXTQGPQKKGEO',
    secretAccessKey: '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',
    region: 'ap-south-1'
  },

  // mapKey: 'AIzaSyByYoLIWwmAub_aBubLt2TgEnoSBMh5lU8'
  mapKey: 'AIzaSyBWUVonYTzHPK4vs0fyawpy2bWXUgtRhKM'
};